module.exports = __webpack_public_path__ + "static/media/screenshot-leaderboard.c62c9dbb.png";